// Use matchMedia instead of putting the media query in CSS so that we can:
//  - keep it behind a flag during development
//  - allow the user to override the preference (otherwise, it's whatever your
//    OS is set to)

class DarkModeManager {
  config_key = 'wsu.dark_mode';

  default_mode = 'light';

  constructor() {
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.currentMatch = this.mediaQuery.matches;
    this.mediaQuery.addEventListener('change', (e) => {
      this.currentMatch = e.matches && this.evaluate();
    });
    this.evaluate();
  }

  evaluate() {
    const pref = this.getUserPreference();
    const wantsDarkMode =
      pref === 'dark' || (pref === 'auto' && this.currentMatch);
    const verb = wantsDarkMode ? 'add' : 'remove';
    document.documentElement.classList[verb]('dark-mode');
  }

  getUserPreference() {
    if (this.config_key in localStorage) {
      return localStorage[this.config_key];
    }

    return this.default_mode;
  }

  setUserPreference(mode) {
    localStorage[this.config_key] = mode;
    this.evaluate();
  }
}

export default DarkModeManager;
